var _dec, _class, _class2, _temp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { Animated, StyleSheet, View } from 'react-native';
import { Size } from "../../devsupport";
import { styled } from "../../theme";
import { SpinnerAnimation } from "./animation";
export
/**
 * Displays a loading state of a page or a section.
 *
 * @extends React.Component
 *
 * @property {boolean} animating - Whether component is animating.
 * Default is *true*.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *primary*.
 * Use *control* status when needed to display within a contrast container.
 *
 * @property {string} size - Size of the component.
 * Can be `tiny`, `small`, `medium`, `large`, or `giant`.
 * Defaults to *medium*.
 *
 * @overview-example SpinnerSimpleUsage
 * Default Spinner status is `primary` and size is `medium`.
 *
 * @overview-example SpinnerSizes
 * To resize Spinner, a `size` property may be used.
 *
 * @overview-example SpinnerStatuses
 * A color can be changed with `status` property
 * An extra status is `control`, which is designed to be used on high-contrast backgrounds.
 *
 * @overview-example SpinnerTheming
 * Styling of Spinner is possible with [configuring a custom theme](guides/branding).
 *
 * @example SpinnerDataLoading
 */
let Spinner = (_dec = styled('Spinner'), _dec(_class = (_temp = _class2 = class Spinner extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "animation", new SpinnerAnimation(this.containerSize.height));

    _defineProperty(this, "startAnimation", () => {
      this.animation.start();
    });

    _defineProperty(this, "stopAnimation", () => {
      this.animation.stop();
    });

    _defineProperty(this, "getComponentStyle", source => {
      const start = {
        container: source.container,
        arc: source.start
      };
      const end = {
        container: source.container,
        arc: source.end,
        overflow: {
          top: this.containerSize.height / 2
        }
      };
      return {
        start,
        end
      };
    });

    _defineProperty(this, "renderArcElement", (style, size) => {
      const arcSize = new Size(size.width, size.height / 2);
      return /*#__PURE__*/React.createElement(Animated.View, {
        style: [StyleSheet.absoluteFill, style.container, size]
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.noOverflow, style.overflow, arcSize]
      }, /*#__PURE__*/React.createElement(Animated.View, {
        style: [style.arc, size]
      }, /*#__PURE__*/React.createElement(View, {
        style: [styles.noOverflow, arcSize]
      }, /*#__PURE__*/React.createElement(View, {
        style: [this.props.eva.style, this.props.style]
      })))));
    });
  }

  get containerSize() {
    const {
      width,
      height
    } = StyleSheet.flatten([this.props.eva.style, this.props.style]); // @ts-ignore: width and height are restricted to be a number

    return new Size(width, height);
  }

  componentDidMount() {
    if (this.props.animating) {
      this.startAnimation();
    }
  }

  componentDidUpdate(prevProps) {
    const animatingChanged = this.props.animating !== prevProps.animating;

    if (animatingChanged && this.props.animating) {
      this.startAnimation();
    }

    if (animatingChanged && !this.props.animating) {
      this.stopAnimation();
    }
  }

  componentWillUnmount() {
    this.animation.release();
  }

  render() {
    const containerSize = this.containerSize;
    const evaStyle = this.getComponentStyle(this.animation.toProps());
    return /*#__PURE__*/React.createElement(View, {
      style: containerSize
    }, this.renderArcElement(evaStyle.start, containerSize), this.renderArcElement(evaStyle.end, containerSize));
  }

}, _defineProperty(_class2, "defaultProps", {
  animating: true
}), _temp)) || _class);
const styles = StyleSheet.create({
  noOverflow: {
    overflow: 'hidden'
  }
});